module.exports = {
  count: 10,
  classname: 'line-clamp',
};
